import { render } from "./ProfileImage.vue?vue&type=template&id=7d93b59a&scoped=true"
import script from "./ProfileImage.vue?vue&type=script&lang=js"
export * from "./ProfileImage.vue?vue&type=script&lang=js"

import "./ProfileImage.vue?vue&type=style&index=0&id=7d93b59a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d93b59a"]])

export default __exports__